import type { Cart } from '@booking/types/booking'

export const MBWAY_POLL_INTERVAL_MS = 2500
export const MBWAY_POLL_MAX_ATTEMPTS = 120

export function normalizeMbWayPhone(phoneRaw: string): string {
  return phoneRaw.trim()
}

export function shouldRebuildMbWayCart(cart: Cart, hasFired: boolean): boolean {
  return cart.status === 'RESERVED' || hasFired
}

export function buildMbWaySuccessPath(cartId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  const qs = new URLSearchParams()
  qs.set('cartId', cartId)
  qs.set('paymentMethod', 'mbway')
  return `${origin}${pathname}?${qs.toString()}`
}

export function buildMbWaySuccessRoute(slug: string, cartId: string): string {
  const qs = new URLSearchParams()
  qs.set('cartId', cartId) //cartId)
  qs.set('paymentMethod', 'mbway')
  qs.set('stage', 'thankyou')
  qs.set('success', 'true')
  return `/${slug}?${qs.toString()}`
}
